import router from '@/router'
export default {
  namespaced: true,
  state: {
    breadCrumbs: [], // 面包屑
    currentSelect: {}
  },
  mutations: {
    setBreadCrumbs (state, payload) {
      // state.breadCrumbs = [payload]
      if (payload.name && !state.breadCrumbs.some(b => b.path === payload.path)) {
        state.breadCrumbs.push(payload)
      }
      // state.breadCrumbs.push(payload)
    },
    setCurrentSelect (state, payload) {
      state.currentSelect = payload
      if (!state.breadCrumbs.find(b => b.name === payload.name)) { // Prevent duplication
        state.breadCrumbs.push(payload)
      }
    },
    clearBreadCrumbs (state) {
      state.breadCrumbs = []
      state.currentSelect = {}
    },
    removeBreadCrumbs (state, payload) {
      // state.breadCrumbs = state.breadCrumbs.filter(item => item.name !== payload)
      // router.go(-1)
      // state.currentSelect = state.breadCrumbs[state.breadCrumbs.length - 1]
      // state.breadCrumbs = state.breadCrumbs.filter(b => b.name !== payload)
      // // 更新当前选中的面包屑，若已删除则选择最后一个
      // if (state.currentSelect.name === payload) {
      //   state.currentSelect = state.breadCrumbs[state.breadCrumbs.length - 1] || {}
      // }
      const index = state.breadCrumbs.findIndex(b => b.name === payload)
      if (index !== -1) {
      // 如果删除的面包屑是当前选中的，或者是最后一个，需要进行路由跳转
        const isCurrentSelect = state.breadCrumbs[index].name === state.currentSelect.name
        const isLastBreadcrumb = index === state.breadCrumbs.length - 1

        state.breadCrumbs.splice(index, 1)

        if (isCurrentSelect || isLastBreadcrumb) {
          if (state.breadCrumbs.length > 0) {
          // 设置新的当前选中的面包屑并跳转
            const newCurrentSelect = state.breadCrumbs[state.breadCrumbs.length - 1]
            state.currentSelect = newCurrentSelect
            router.push(newCurrentSelect.path)
          } else {
          // 面包屑为空，跳转到默认页面
            state.currentSelect = {}
          // router.push('/default-route');
          }
        }
      }
    }
  },
  actions: {},
  getters: {}
}
